import { render, staticRenderFns } from "./peaStatusWorkflow.vue?vue&type=template&id=3f4b60da&scoped=true"
import script from "./peaStatusWorkflow.vue?vue&type=script&lang=js"
export * from "./peaStatusWorkflow.vue?vue&type=script&lang=js"
import style0 from "./peaStatusWorkflow.vue?vue&type=style&index=0&id=3f4b60da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b60da",
  null
  
)

export default component.exports